module.exports = __webpack_public_path__ + "static/media/box2.295da775.jpeg";